import { createActions } from 'redux-actions';

const actions = createActions({
  TASK: {
    SET_ASSIGNED_USERS: (assignedUsers) => ({ assignedUsers }),
    API: {
      SET_ASSIGNED_USERS: undefined
    }
  }
})

const configuration = {
  name: 'setAssignedUsers',
  action: actions,
  sagas: undefined,
  reducers: {
    reducer: (state, action) => ({
      ...state,
      createTask: {
        ...state.createTask,
        assignedUsers: action.payload.assignedUsers
      },
    })
  }
}

export default configuration;


// WEBPACK FOOTER //
// ./src/state/modules/task/configurations/setAssignedUsers.js